import { useEffect } from 'react';
import { getFormattedDuration } from '../../Utils/TestResultsMethods';
import { isSameData } from '../../Utils/helpers';
import {
  REGIONS_DICTIONARY,
  ENVIRONMENTS_DICTIONARY,
  PENDING,
  RUNNING,
  EDITED,
} from '../../Constants/constants';

export const useTestExecutionData = ({
  data,
  user,
  showFavorites,
  showScheduled,
  testExecutions,
  setTestExecutions,
  stopResumeScheduledExecution,
  selectedToSchedule,
}) => {
  const updateTestExecutions = (filteredTestExecutions) => {
    const temp = filteredTestExecutions.map((test) => {
      const startDate =
        test.start && test.status !== EDITED
          ? new Date(test.start).toLocaleString('en-US', {
              hour12: false,
            })
          : '----';
      const seconds = test.duration;
      const formattedDuration = [RUNNING, PENDING, EDITED].includes(test.status)
        ? '--:--:--'
        : getFormattedDuration(Math.abs(seconds));

      const name = test.name ? test.name : 'No name.';
      const email = test.login ? test.login : 'No user.';

      const failed_total =
        test.status !== EDITED ? `${test.failed}/${test.total}` : '----';
      const { status } = test;
      const passed = test.passed === test.total;

      const userOwnsTest = test.userId === user._id;

      return {
        id: test._id,
        env: ENVIRONMENTS_DICTIONARY[test.env],
        date: startDate,
        name,
        email,
        status,
        passed,
        failed_total,
        executionStatus: test.executionStatus,
        duration: formattedDuration,
        region: test.region && REGIONS_DICTIONARY[test.region],
        description: test.description,
        userOwnsTest,
        isFavourite: test.isFavourite,
        isScheduled: test.isScheduled,
        clients: test.clients,
      };
    });
    if (isSameData(temp, testExecutions)) return;

    setTestExecutions(temp);
  };

  const onStopResumeScheduledExecution = (pausing) => {
    stopResumeScheduledExecution({
      variables: { listId: selectedToSchedule, pausing: pausing },
    })
      .then((res) => {
        window.flash(
          'Scheduled executions successfully ' +
            (pausing ? 'paused' : 'resumed'),
          'success'
        );
      })
      .catch((error) => {
        window.flash('An error occured. Please try again later', 'error');
      });
  };

  useEffect(() => {
    if (!data) return;

    if (!showFavorites && !showScheduled) {
      updateTestExecutions(data);
      return;
    }
    let filteredTestExecutions = [...data];
    if (showFavorites) {
      filteredTestExecutions = filteredTestExecutions.filter((test) => {
        return test.isFavourite && test.userId === user._id;
      });
    }
    if (showScheduled) {
      filteredTestExecutions = filteredTestExecutions.filter(
        (test) => test.isScheduled
      );
    }
    updateTestExecutions(filteredTestExecutions);
  }, [showFavorites, data, showScheduled]); // eslint-disable-line

  return {
    updateTestExecutions,
    onStopResumeScheduledExecution,
  };
};
